import { render, staticRenderFns } from "./OicListAdd.vue?vue&type=template&id=4276e94f&scoped=true&"
import script from "./OicListAdd.vue?vue&type=script&lang=js&"
export * from "./OicListAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276e94f",
  null
  
)

export default component.exports